import { Popover, Space, Tag } from '@bedrock/components'
import { Crown, LevelDown, NoticeTextPlus2 } from '@bedrock/icons-react'
import { CellDescriptions } from '@mpc/components'
import React from 'react'
import { EllipsisTooltip } from '@mpc/components';

const SupplierCell = ({ mode = 'cell', record: v }) => {
  const isCell = mode === 'cell';
  return (
    <Space size='small' wrap={!isCell} style={{ width: isCell ? undefined : 400 }}>
      <EllipsisTooltip clamp={isCell ? 1 : 100} text={v.supplier_name} noTooltip />
      {Number(v.is_exclusive_supplier) === 1 &&
        <Tag
          text="独家资源"
          color="light-orange"
          border={true}
          size="xSmall"
          icon={<Crown />}
          className='white-space-nowrap'
        />
      }
      {
        Number(v.is_lowest_price_last6m) === 1 &&
        <Tag
          text={isCell ? "最低价" : "6个月内最低价"}
          color="light-green"
          border={true}
          size="xSmall"
          icon={<LevelDown />}
          className='white-space-nowrap'
        />
      }
      {
        Number(v.is_most_coop_last6m) === 1 &&
        <Tag
          text={isCell ? "合作最多" : "6个月内合作最多"}
          color="light-green"
          border={true}
          size="xSmall"
          icon={<NoticeTextPlus2 />}
          className='white-space-nowrap'
        />
      }
    </Space>
  )
}

/**
 * 供应商
 */
const SupplierListCell = ({
  record
}) => {
  if (!record?.demand_source_kol_content_vo?.kol_supplier_volist?.length) {
    return '--'
  }
  return (
    <CellDescriptions
      colon={false}
      maxDisplayCount={4}
      column={1}
      items={record?.demand_source_kol_content_vo?.kol_supplier_volist?.map(v => {
        return {
          children: (
            <Popover
              content={(
                <SupplierCell mode='popover' record={v} />
              )}
            >
              <div><SupplierCell record={v} /></div>
            </Popover>
          )
        }
      })}
    />
  )
}

export default SupplierListCell
